<template>
  <div class="main_div">
    <canvas id="canvas3" style="position: absolute; bottom: 0px; left: 0px;width: 5120px;height: 1080px;"></canvas>
    <canvas id="canvas2" style="position: absolute; bottom: 0px; left: 1945px;width: 1230px;height: 1080px;">抱歉，您的浏览器不支持canvas元素</canvas>
    <div class="lb">
      <div class="lb-top">
        <li class="clor-g">
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <span id="clock"></span>
        <li>
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <img src="../images/cdz.png" alt="" style="position: absolute;width: 90px;left: 25px;top:10px;">
          <div class="title0">充电桩总数（个）</div><div class="js-box box number1"></div>
        </li>
        <li>
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0">充电容量（kW）</div> <div class="js-box box number2"></div>
        </li>
        <li>
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0">累计充电量（kWh）</div><div class="js-box box number3"></div>
        </li>
        <div class="tis margin-l0">
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0"><span>用</span><span>户</span><span>概</span><span>况</span></div>
        </div>
        <div class="tis">
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0"><span>运</span><span>营</span><span>监</span><span>控</span></div>
        </div>
      </div>
      <div class="lb-center">
        <li>
          <div class="lb1 margin-l0">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <img src="../images/car.png" alt="" style="position: absolute;width: 40px;top: 40px;left: 30px;">
            <img src="../images/car.png" alt="" style="position: absolute;width: 40px;top: 137px;left: 30px;">
            <div class="title4">注册用户数(个)</div>
            <div class="lbt1">{{member.customerNum}}</div>
            <div class="title4">活跃用户数(个)</div>
            <div class="lbt2">{{order.dailyOrder.orderNum}}</div>
          </div>
          <div class="lb2">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">活跃用户比</div>
            <div class="char" id="lb2"></div>
          </div>
          <div class="lb3">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">充电服务</div>
            <div class="char" id="lb3"></div>
          </div>
          <div class="lb4">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">充电桩数量地区分布</div>
            <div class="char" id="lb4"></div>
          </div>
          <div class="lb5">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">充电量分布</div>
            <div class="char" id="lb5"></div>
          </div>
        </li>
        <li>
          <div class="lb6 margin-l0">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">近30天活跃用户量</div>
            <div class="char" id="lb6"></div>
          </div>
          <div class="lb7">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">支付服务</div>
            <div class="char">
              <div class="title2  margin-l0">今日支付(次)</div>
              <div class="title2">累计支付(次)</div>
              <div class="number  margin-l0">{{order.dailyOrder.orderNum}}</div>
              <div class="number">{{order.totalOrder.orderNum}}</div>
              <!--<div class="title2 margin-l0" style=" width:100% !important;">支付类型分布</div>-->
              <div id="lb7" style="height:126px;width:100%;"></div>
            </div>
          </div>
          <div class="lb8 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">枪实时情况</div>
            <div class="char2" id="lb8"></div>
          </div>
        </li>
        <li>
          <div class="lb9 margin-l0 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">用户增长</div>
            <div class="char2" id="lb9"></div>
          </div>
          <div class="lb10 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">运营情况分析</div>
            <div class="char2" id="lb10"></div>
          </div>
          <div class="lb11 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">充电分析</div>
            <div class="char2" id="lb11"></div>
          </div>
        </li>
        <li>
          <div class="lb12 margin-l0 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">城市活跃用户TOP</div>
            <div class="char" id="lbtop"></div>
          </div>
          <div class="lb13 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">用户活跃分布</div>
            <div class="char2" id="lb13"></div>
          </div>
          <div class="lb14 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">充电服务统计</div>
            <div class="char2" id="lb14"></div>
          </div>
        </li>
      </div>
    </div>
    <div class="center">
      <div class="center-top">
        <img src="../images/logo.png" style="display: block;float: left;width: 400px;"/>
        <div class="logo">腾亿新能源充电运营管理平台</div>
        <li class="margin-l0">
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          将减少汽油消耗<p>{{Math.round(order.totalOrder.totalElectricity*0.3/10000)}}吨</p></li>
        <li>
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          减少原油消耗<p>{{Math.round(order.totalOrder.totalElectricity*0.3*0.6/10000)}}吨</p></li>
        <li>
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          相当于植树<p>{{Math.round(order.totalOrder.totalElectricity*0.997*18/10000)}}棵</p></li>
        <li>
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          减少CO2排量 <p>{{Math.round(order.totalOrder.totalElectricity*0.997/10000)}}吨</p></li>
      </div>
      <div class="zsj">
        <li><span class="margin-l0">场站接入(个)</span></li>
        <li>合计<span>{{res.res.stationNum}}</span></li>
        <li>自营站<span>{{res.joinRes.selfStationNum}}</span></li>
        <li>独立运营站<span>{{res.joinRes.independentStationNum}}</span></li>
        <li>代理运营站<span>{{res.joinRes.proxyStationNum}}</span></li>
        <li>互联互通站<span>{{res.joinRes.cecStationNum}}</span></li>
      </div>
      <div class="zxj">
        <li><span class="margin-l0">充电桩接入(个)</span></li>
        <li>合计<span>{{res.joinRes.selfPileNum+res.joinRes.independentPileNum+res.joinRes.cecPileNum+res.joinRes.proxyPileNum}}</span></li>
        <li>自运营快充桩<span>{{res.joinRes.selfPileFastNum}}</span></li>
        <li>自运营慢充桩<span>{{res.joinRes.selfPileSlowNum}}</span></li>
        <li>自运营桩<span>{{res.joinRes.selfPileNum}}</span></li>
        <li>独立运营桩<span>{{res.joinRes.independentPileNum}}</span></li>
        <li>互联互通桩<span>{{res.joinRes.cecPileNum}}</span></li>
        <li>代理运营桩<span>{{res.joinRes.proxyPileNum}}</span></li>
      </div>
      <div class="map-icon-ico">
        <a href="javascript:;" class="link-icon1 link-icon"></a>
        <a href="javascript:;" class="link-icon2 link-icon"></a>
        <a href="javascript:;" class="link-icon3 link-icon"></a>
        <a href="javascript:;" class="link-icon4 link-icon"></a>
      </div>
      <a class="map-type" href="javascript:void(0)">
        <img src="../images/city1.png" class="map-icon"/>
        <span class="map-text">全国</span>
      </a>
      <div class="form-margin form-city-arr">
        <span class="form-lable" @click="rowArr('全国')">全国</span>
        <span class="form-lable" @click="rowArr('北京')">北京</span>
        <span class="form-lable" @click="rowArr('上海')">上海</span>
        <span class="form-lable" @click="rowArr('天津')">天津</span>
        <span class="form-lable" @click="rowArr('重庆')">重庆</span>
        <span class="form-lable" @click="rowArr('河北')">河北</span>
        <span class="form-lable" @click="rowArr('山西')">山西</span>
        <span class="form-lable" @click="rowArr('河南')">河南</span>
        <span class="form-lable" @click="rowArr('辽宁')">辽宁</span>
        <span class="form-lable" @click="rowArr('吉林')">吉林</span>
        <span class="form-lable" @click="rowArr('黑龙江')">黑龙江</span>
        <span class="form-lable" @click="rowArr('内蒙古')">内蒙古</span>
        <span class="form-lable" @click="rowArr('江苏')">江苏</span>
        <span class="form-lable" @click="rowArr('山东')">山东</span>
        <span class="form-lable" @click="rowArr('安徽')">安徽</span>
        <span class="form-lable" @click="rowArr('浙江')">浙江</span>
        <span class="form-lable" @click="rowArr('福建')">福建</span>
        <span class="form-lable" @click="rowArr('湖北')">湖北</span>
        <span class="form-lable" @click="rowArr('湖南')">湖南</span>
        <span class="form-lable" @click="rowArr('广东')">广东</span>
        <span class="form-lable" @click="rowArr('广西')">广西</span>
        <span class="form-lable" @click="rowArr('江西')">江西</span>
        <span class="form-lable" @click="rowArr('四川')">四川</span>
        <span class="form-lable" @click="rowArr('海南')">海南</span>
        <span class="form-lable" @click="rowArr('贵州')">贵州</span>
        <span class="form-lable" @click="rowArr('云南')">云南</span>
        <span class="form-lable" @click="rowArr('西藏')">西藏</span>
        <span class="form-lable" @click="rowArr('陕西')">陕西</span>
        <span class="form-lable" @click="rowArr('甘肃')">甘肃</span>
        <span class="form-lable" @click="rowArr('青海')">青海</span>
        <span class="form-lable" @click="rowArr('宁夏')">宁夏</span>
        <span class="form-lable" @click="rowArr('新疆')">新疆</span>
        <span class="form-lable" @click="rowArr('台湾')">台湾</span>
        <span class="form-lable" @click="rowArr('香港')">香港</span>
        <span class="form-lable" @click="rowArr('澳门')">澳门</span>
      </div>
      <div class="map-por">
        <div class="center-map" id="gzmap"></div>
        <p class="icon-top"></p>
        <p class="icon-bottom"></p>
      </div>
    </div>
    <div class="lb">
      <div class="lb-top">
        <li><p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0">当日充电量（kWh）</div><div class="js-box box number4"/></li>
        <li><p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0">当日服务次数（次）</div> <div class="js-box box number5"/></li>
        <li><p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0">累积服务次数（次）</div> <div class="js-box box number6"/></li>
        <li><p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0">安全运行天数（天）</div> <div class="js-box box number7"/></li>
        <div class="tis margin-l0">
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0"><span>场</span><span>站</span><span>监</span><span>控</span></div>
        </div>
        <div class="tis">
          <p class="icon-top-head"></p>
          <p class="icon-bottom-head"></p>
          <div class="title0"><span>延</span><span>伸</span><span>服</span><span>务</span></div>
        </div>
      </div>
      <div class="lb-center">
        <li>
          <div class="lb15 margin-l0">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">充电站分布</div>
            <div class="char" id="lb15"></div>
          </div>
          <div class="lb16">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">站点充电排行TOP</div>
            <div class="char" id="lb16"></div>
          </div>
          <div class="map-min-por">
            <div class="lb17 char1" style="margin-left: 0;" id="lb17"></div>
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
          </div>
        </li>
        <li>
          <div class="lb18 margin-l0">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title4">充电桩详细信息</div>
            <div class="char" id="lb18">
              <div class="one">
                <div class="title3">充电桩个数</div>
                <div class="one-n">
                  <img src="../images/cdz.png" alt="" style="position: absolute;width: 70px;left: 5px;top:25px;">
                  <span class="number10" style="left: 35px;">{{res.res.pileNum}}</span>
                </div>
              </div>
              <div class="one">
                <div class="title3">当月收入</div>
                <div class="one-v">{{currentMonthData.totalFee}}</div>
                <div class="one-t">
                  <div v-show="currentMonthData.totalFee/beforeMonthData.totalFee < 0"><span class="red">↓</span></div>
                  <div v-show="currentMonthData.totalFee/beforeMonthData.totalFee > 0"><span style="padding-left: 10px">↑</span></div>
                  {{(currentMonthData.totalFee/beforeMonthData.totalFee * 100).toFixed(2)}}%同上月比较</div>
              </div>
              <div class="one">
                <div class="title3">当月充电量</div>
                <div class="one-v">{{currentMonthData.totalElectricity}}</div>
                <div class="one-t">
                  <div v-show="currentMonthData.totalElectricity/beforeMonthData.totalElectricity < 0"><span class="red">↓</span></div>
                  <div v-show="currentMonthData.totalElectricity/beforeMonthData.totalElectricity > 0"><span style="padding-left: 10px">↑</span></div>
                  {{(currentMonthData.totalElectricity/beforeMonthData.totalElectricity * 100).toFixed(2)}}%同上月比较</div>
              </div>
              <div class="one">
                <div class="title3">当月服务次数</div>
                <div class="one-v">{{currentMonthData.orderNum}}</div>
                <div class="one-t">
                  <div v-show="currentMonthData.orderNum/beforeMonthData.orderNum < 0"><span class="red">↓</span></div>
                  <div v-show="currentMonthData.orderNum/beforeMonthData.orderNum > 0"><span style="padding-left: 10px">↑</span></div>
                  {{(currentMonthData.orderNum/beforeMonthData.orderNum * 100).toFixed(2)}}%同上月比较
                </div>
              </div>
            </div>
          </div>
          <div class="lb19 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">分区域充电设施预测</div>
            <div class="char2" id="lb19"></div>
          </div>
          <div class="lb20 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">充电汽车充电量及充电负荷测算</div>
            <div class="char2" id="lb20"></div>
          </div>
        </li>
        <li>
          <div class="lb21 char1 margin-l0">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">近10天充电量和充电金额</div>
            <div class="char2" id="lb21"></div>
          </div>
          <div class="lb22 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">电动汽车充电设施及建设规模</div>
            <div class="char2" id="lb22"></div>
          </div>
          <div class="lb23 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">拉动电动汽车及动力电池产值预算</div>
            <div class="char2" id="lb23"></div>
          </div>
        </li>
        <li>
          <div class="lb24 char1 margin-l0">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">{{order.currentMonthOrder.month}}月充电订单来源</div>
            <div class="char2">
              <div style="width: 50%">
                <div  style="width: 230px;height: 170px;" id="ringDiagram"></div>
              </div>
              <div style="width: 50%">
                <div v-for="(item,index) in orderSourceMap" :key="index">
                  <span style="color:#c27461;">●</span>
                  <span style="color:#29b9d7;" >{{index}} {{item}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="lb25 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">订单分布</div>
            <div class="char2" id="lb25"></div>
          </div>
          <div class="lb26 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">充电汽车节能排除故障</div>
            <div class="char2" id="lb26"></div>
          </div>
          <div class="lb27 char1">
            <p class="icon-top"></p>
            <p class="icon-bottom"></p>
            <div class="title1">电动汽车保有量预测</div>
            <div class="char2" id="lb27"></div>
          </div>
        </li>
      </div>
    </div>
  </div>
</template>
<script>
  import dataVisualApi from '../../monitoringCenter/api/dataVisualApi'
  import city from '../jsons/city.json'
  import json19 from '../jsons/json19.json'
  import json20 from '../jsons/json20.json'
  import jsonmap from '../jsons/jsonmap.json'
  import mapCityData from '../jsons/mapCityData.json'
  import $ from 'jquery';
  import Chart from "echarts";
  require('echarts/map/js/province/guizhou')
  require('echarts/map/js/province/anhui')
  require('echarts/map/js/province/aomen')
  require('echarts/map/js/province/beijing')
  require('echarts/map/js/province/chongqing')
  require('echarts/map/js/province/fujian')
  require('echarts/map/js/province/gansu')
  require('echarts/map/js/province/guangdong')
  require('echarts/map/js/province/guangxi')
  require('echarts/map/js/province/hainan')
  require('echarts/map/js/province/hebei')
  require('echarts/map/js/province/heilongjiang')
  require('echarts/map/js/province/henan')
  require('echarts/map/js/province/hubei')
  require('echarts/map/js/province/hunan')
  require('echarts/map/js/province/jiangxi')
  require('echarts/map/js/province/jilin')
  require('echarts/map/js/province/liaoning')
  require('echarts/map/js/province/jiangsu')
  require('echarts/map/js/province/neimenggu')
  require('echarts/map/js/province/ningxia')
  require('echarts/map/js/province/qinghai')
  require('echarts/map/js/province/shandong')
  require('echarts/map/js/province/shanghai')
  require('echarts/map/js/province/shanxi')
  require('echarts/map/js/province/shanxi1')
  require('echarts/map/js/province/sichuan')
  require('echarts/map/js/province/tianjin')
  require('echarts/map/js/province/xianggang')
  require('echarts/map/js/province/xinjiang')
  require('echarts/map/js/province/xizang')
  require('echarts/map/js/province/yunnan')
  require('echarts/map/js/province/zhejiang')
  require('echarts/map/js/china')
  import operatingViewScreenApi from '../../monitoringCenter/api/operatingViewScreenApi'
  export default {
    data() {
      return {
        color: ['#fca1a0','#beffff','#0e9cff','#41fa9d','#a0feff','#fff','#faa4ff','#fdfcbc','#fdfcbc','#a3feff','#aefbff'],
        mapchart: null,
        lab2Chart: null,
        lab3Chart: null,
        lab4Chart: null,
        lab5Chart: null,
        lab6Chart: null,
        lab7Chart: null,
        lab8Chart: null,
        lab9Chart: null,
        lab10Chart: null,
        lab11Chart: null,
        lab13Chart: null,
        lab14Chart: null,
        lab15Chart: null,
        lab16Chart: null,
        lab17Chart: null,
        lab19Chart: null,
        lab20Chart: null,
        lab21Chart: null,
        lab22Chart: null,
        lab23Chart: null,
        lab24Chart: null,
        lab25Chart: null,
        lab26Chart: null,
        lab27Chart: null,
        lab28Chart: null,
        canvas: null,
        canvas2: null,
        canvas3: null,
        w: 0,
        h: 0,
        hue: 217,
        half: 0,
        stars: [],
        maxStars: 1000,//星星数量
        orderSourceMap: {},
        order: {
          payType: {},
          orderSource: {},
          totalOrder: {},
          dailyOrder: {},
          monthlyOrder: {},
          yearlyOrder: {},
          operatorDailyRank: {},
          stationDailyRank: {},
          operatorMonthlyRank: {},
          stationMonthlyRank: {},
          orderMonthlyList: {},
          orderStateMonthly: {},
          currentMonthOrder: {},
        },
        currentMonthData: {},
        beforeMonthData: {},
        member: {},
        ops: {
          alarmType: {},
          statistic: {}
        },
        res: {
          operators: {},
          joinRes: {
            stationNum: ''
          },
          res:{},
          resGunHour:{},
          onlineRate:'',
          accuracy:''
        },
        mapData: {}
      }
    },
    mounted()  {
      this.getOrderStatistics()
      this.getMapData()
      this.showtime();
      this.canvas = document.getElementById('canvas2');
      this.canvas2 =  document.createElement('canvas');
      this.canva3 = document.getElementById('canvas3');
      this.mapchart =  Chart.init(document.getElementById('gzmap'));
      this.lab2Chart = Chart.init(document.getElementById('lb2'));
      this.lab3Chart = Chart.init(document.getElementById('lb3'));
      this.lab4Chart = Chart.init(document.getElementById('lb4'));
      this.lab5Chart = Chart.init(document.getElementById('lb5'));
      this.lab6Chart = Chart.init(document.getElementById('lb6'));
      this.lab7Chart = Chart.init(document.getElementById('lb7'));
      this.lab8Chart = Chart.init(document.getElementById('lb8'));
      this.lab9Chart = Chart.init(document.getElementById('lb9'));
      this.lab10Chart = Chart.init(document.getElementById('lb10'));
      this.lab11Chart = Chart.init(document.getElementById('lb11'));
      this.lab13Chart = Chart.init(document.getElementById('lb13'));
      this.lab14Chart = Chart.init(document.getElementById('lb14'));
      this.lab15Chart = Chart.init(document.getElementById('lb15'));
      this.lab16Chart = Chart.init(document.getElementById('lb16'));
      this.lab17Chart = Chart.init(document.getElementById('lb17'));
      this.lab19Chart = Chart.init(document.getElementById('lb19'));
      this.lab20Chart = Chart.init(document.getElementById('lb20'));
      this.lab21Chart = Chart.init(document.getElementById('lb21'));
      this.lab22Chart = Chart.init(document.getElementById('lb22'));
      this.lab23Chart = Chart.init(document.getElementById('lb23'));
      //this.lab24Chart = Chart.init(document.getElementById('lb24'));
      this.lab25Chart = Chart.init(document.getElementById('lb25'));
      this.lab26Chart = Chart.init(document.getElementById('lb26'));
      this.lab27Chart = Chart.init(document.getElementById('lb27'));
      this.lab28Chart = Chart.init(document.getElementById('ringDiagram'));
      this.labtopChart = Chart.init(document.getElementById('lbtop'));
      this.initCanvas();
      for (let  i = 0; i < this.maxStars; i++) {
        this.star();
      }
      this.animation();
    },
    updated: function () {
      this.initmap(jsonmap.data);
    },
    methods: {
      getOrderStatistics() {
        operatingViewScreenApi.getOrderStatistics().then((res) => {
          if (res) {
            //订单信息
            this.order.payType = res.order.payType
            this.order.orderSource = res.order.orderSource
            this.order.totalOrder = res.order.totalOrder
            this.order.dailyOrder = res.order.dailyOrder
            this.order.monthlyOrder = res.order.monthlyOrder
            this.order.yearlyOrder = res.order.yearlyOrder
            this.order.operatorDailyRank = res.order.operatorDailyRank
            this.order.stationDailyRank = res.order.stationDailyRank
            this.order.operatorMonthlyRank = res.order.operatorMonthlyRank
            this.order.stationMonthlyRank = res.order.stationMonthlyRank
            this.order.orderMonthlyList = res.order.orderMonthlyList
            this.order.orderStateMonthly = res.order.orderStateMonthly
            //会员信息
            this.member = res.member
            //运维信息
            this.ops = res.ops
            //资源信息
            this.res = res.res
            this.lab2();
            this.lab3();
            this.lab8();
            this.lab17();
            this.initialization();
          } else {
          }
        })
      },
      getMapData() {
        let param = {
          t: {
            isPage: false
          }
        }
        param = Object.assign({}, param)
        operatingViewScreenApi.getMapData(param).then((res) => {
          if (res.code == 0) {
            this.mapData = res.data
          } else {
          }
        })
      },
      showtime: function() {
        var today;
        var hour;
        var second;
        var minute;
        var year;
        var month;
        var date;
        var strDate;
        today = new Date();
        var n_day = today.getDay();
        switch (n_day) {
          case 0: {
            strDate = "星期日"
          }
            break;
          case 1: {
            strDate = "星期一"
          }
            break;
          case 2: {
            strDate = "星期二"
          }
            break;
          case 3: {
            strDate = "星期三"
          }
            break;
          case 4: {
            strDate = "星期四"
          }
            break;
          case 5: {
            strDate = "星期五"
          }
            break;
          case 6: {
            strDate = "星期六"
          }
            break;
          case 7: {
            strDate = "星期日"
          }
            break;
        }
        year = today.getFullYear();
        month = today.getMonth() + 1;
        date = today.getDate();
        hour = today.getHours();
        minute = today.getMinutes();
        second = today.getSeconds();
        if (month < 10)
          month = "0" + month;
        if (date < 10)
          date = "0" + date;
        if (hour < 10)
          hour = "0" + hour;
        if (minute < 10)
          minute = "0" + minute;
        if (second < 10)
          second = "0" + second;
        document.getElementById('clock').innerHTML = year + "年" + month + "月"
          + date + "日 " + strDate + "<p style='margin: -10px;font-size: 12px;'>&nbsp;</p>" + hour + ":" + minute + ":" + second;
        setTimeout(() => {
          this.showtime();
        }, 1000)
      },
      initCanvas: function(){
        this.w = this.canvas.width = window.innerWidth;
        this.h = this.canvas.height = window.innerHeight;
        this.canvas2.width = 100;
        this.canvas2.height = 100;
        this.half = this.canvas2.width / 8;
        let ctx2 = this.canvas2.getContext('2d');
        let gradient2 = ctx2.createRadialGradient(this.half, this.half, 0, this.half, this.half, this.half);
        gradient2.addColorStop(0.025, '#CCC');
        gradient2.addColorStop(0.1, 'hsl(' + this.hue + ', 61%, 33%)');
        gradient2.addColorStop(0.25, 'hsl(' + this.hue + ', 64%, 6%)');
        gradient2.addColorStop(1, 'transparent');
        ctx2.fillStyle = gradient2;
        ctx2.beginPath();
        ctx2.arc(this.half, this.half, this.half, 0, Math.PI * 2);
        ctx2.fill();
      },
      animation: function () {
        let ctx =  this.canvas.getContext('2d');
        let ctx3 = this.canva3.getContext('2d');
        ctx3.globalCompositeOperation = 'source-over';
        ctx3.globalAlpha = 0.5; //尾巴
        ctx3.fillStyle = 'hsla(' + this.hue + ', 64%, 6%, 2)';
        ctx3.fillRect(0, 0, this.w, this.h);
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 0.5; //尾巴
        ctx.fillStyle = 'hsla(' + this.hue + ', 64%, 6%, 2)';
        ctx.fillRect(0, 0, this.w, this.h)

        ctx.globalCompositeOperation = 'lighter';
        for (let  i = 0; i < this.stars.length; i++) {
          this.draw(this.stars[i],ctx);
        };
        window.requestAnimationFrame(this.animation.bind(this));
      },
      initmap: function (){
        var data = []
        var totalNumList = []
        for (let i = 0; i < this.mapData.length; i++) {
          totalNumList.push(this.mapData[i].totalNum)
          data[i] = {
            name: this.mapData[i].stationName,
            value: [
              this.mapData[i].lng,
              this.mapData[i].lat,
              this.mapData[i].totalNum,
              this.mapData[i].fastNum,
              this.mapData[i].slowNum,
              this.mapData[i].address,
              this.mapData[i].totalNum
            ]
          }
        }
        //console.log('data:' + JSON.stringify(data))
        totalNumList.sort()
        // totalNumList.reverse()
        let max = totalNumList[totalNumList.length-1]==null?0:totalNumList[totalNumList.length-1];
        let optionMap = {
          title: {
            text: '全国各省份站点数量分布图',
            left: 'center',
            top: 20,
            textStyle: {
              color: '#30e3e9'
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: function (param) {
              return "<div style='text-align: left'><span style='font-size: 10px;color: #30e3e9'>" +
                "名称: " + param.name +
                "<br/>桩数量: " + param.value[2] +
                "<br/>快充桩数量: " + param.value[3] +
                "<br/>慢充桩数量: " + param.value[4] +
                "<br/>地址: " + param.value[5] + "</span></div>"
            }
          },
          visualMap: {
            show: false,
            min: 0,
            max: max,
            left: 'left',
            top: 'bottom',
            text: ['数量最高', '数量最低'],
            calculable : true,
            color:['#f4000a','#f4aa47','#f43bf4',
              '#302ff4','#4cf4e1','#0cff31'],
            textStyle: {
              color: 'rgb(255,255,255)'
            }
          },
          geo: {
            map: 'china',
            center: [104.114129, 37.550339],
            top:10,
            zoom: 1,
            roam: false,
            label: {
              normal: {
                show: true, //显示省份标签
                borderColor:"#00cbfe",
                areaColor:'rgba(12, 143, 233, 0.5)',
                textStyle: {
                  fontSize: '14',
                  color: "#9da8ba"
                } //省份标签字体颜色
              },
              emphasis: { //对应的鼠标悬浮效果
                show: false,
                textStyle: {
                  fontSize: '18',
                  color: "#fff"
                }
              }
            },
            itemStyle: {
              normal: {
                borderColor:"#00cbfe",
                areaColor:'rgba(12, 143, 233, 0.5)',
                areaColor: "#e7f6f9",
                borderColor: "#0e1327"
              },
              emphasis: {
                areaColor: "#0cacc2",
                borderColor: "#0cacc2"
              }
            },
            emphasis: {
              itemStyle: {
                color: "#30e3e9"
              }
            }

          },
          series : [
            {
              name: '',
              type: 'effectScatter',
              coordinateSystem: 'geo',
              data: data,
              symbolSize: function (val) {
                if (val[2] / 35 < 15) return 15
                if (val[2] / 35 > 35) return 35
                return val[2] / 35;
              },
              showEffectOn: 'render',
              rippleEffect: {
                brushType: 'stroke',
                scale: 8,
                period:5
              },
              hoverAnimation: true,
              label: {
                normal: {
                  formatter: '{b}',
                  position: 'right',
                  show: false
                }
              },
              itemStyle: {
                normal: {
                  borderColor:"#00cbfe",
                  areaColor:'rgba(12, 143, 233, 0.5)',
                  shadowBlur: 10,
                  shadowColor: 'rgba(20,20,20,0.6)'
                },
                emphasis:{
                  borderColor:"#00cbfe",
                  areaColor:'#0193e9',
                  label:{
                    show:true,
                    textStyle: {
                      color: "#ffffff"
                    }
                  }
                }
              },
              zlevel: 1
            }
          ]
        }
        this.mapchart.setOption(optionMap,true);
      },
      setCityData: function(_cityData){
        this.mapchart.setOption({
          series: [{
            name: '充电桩分布',
            data:_cityData
          }],
          geo:{
            itemStyle:{
              normal: {
                borderColor:"#00cbfe",
                areaColor:'rgba(12, 143, 233, 0.5)',
                label:{
                  show:true,
                  textStyle: {
                    color: "#ffffff"
                  }
                }
              },
              emphasis:{
                borderColor:"#00cbfe",
                areaColor:'#0193e9',
                label:{
                  show:true,
                  textStyle: {
                    color: "#ffffff"
                  }
                }
              }
            }
          }
        });
      },
      lab2: function (){
        let option = {
          tooltip : {
            formatter: "{a} <br/>{b} : {c}%"
          },
          series : [
            {
              name:'活跃用户比',
              type:'gauge',
              splitNumber: 10,
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[0.2, '#88fcfc'],[0.8, '#409EFF'],[1, '#f1837a']],
                  width:5
                }
              },
              axisTick: {            // 坐标轴小标记
                splitNumber: 10,   // 每份split细分多少段
                length :6,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              axisLabel:{
                show:false
              },
              splitLine:{
                length :10,
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              pointer : {
                width : 2
              },
              detail : {
                formatter:'{value}%',
                offsetCenter: [0, '95%'],
                textStyle: {
                  color: 'auto',
                  fontSize : 24
                }
              },
              data:[{value: 0}]
            }
          ]
        };
        this.lab2Chart.setOption(option, true);
      },
      setLab2Data: function(_value){
        this.lab2Chart.setOption({series: [{
            data:[{value:_value}]
          }]});
      },
      lab3: function (){
        let option = {
          tooltip : {
            formatter: "{a} <br/>{b} : {c}次"
          },
          series : [
            {
              name:'今日达到（次）',
              type:'gauge',
              splitNumber: 10,
              center:['25%','50%'],
              startAngle:230,
              endAngle:105,
              min:0,
              max:10000,
              title:{
                offsetCenter: ['25%', '-40%'],
                textStyle: {
                  color: '#88fcfc',
                  fontSize : 14
                }
              },
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[0.2, '#88fcfc'],[0.8, '#409EFF'],[1, '#f1837a']],
                  width:5
                }
              },
              axisTick: {            // 坐标轴小标记
                splitNumber: 10,   // 每份split细分多少段
                length :6,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              splitLine:{
                length :10,
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              axisLabel:{
                show:false
              },
              pointer : {
                width : 2
              },
              detail : {
                offsetCenter: ['10%', '60%'],
                textStyle: {
                  color: 'auto',
                  fontSize : 24
                }
              },
              data:[{value: 0, name: '今日达到（次）'}]
            },
            {
              name:'累计达到（次）',
              type:'gauge',
              splitNumber: 10,
              center:['75%','50%'],
              startAngle:75,
              endAngle:-50,
              min:0,
              max:1000,
              title:{
                offsetCenter: ['-25%', '-40%'],
                textStyle: {
                  color: '#88fcfc',
                  fontSize : 14
                }
              },
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[0.2, '#88fcfc'],[0.8, '#409EFF'],[1, '#f1837a']],
                  width:5
                }
              },
              axisTick: {            // 坐标轴小标记
                splitNumber: 10,   // 每份split细分多少段
                length :6,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              splitLine:{
                length :10,
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              axisLabel:{
                show:false
              },
              pointer : {
                width : 2
              },
              detail : {
                offsetCenter: ['-10%', '60%'],
                textStyle: {
                  color: 'auto',
                  fontSize : 24
                }
              },
              data:[{value: 0, name: '累计达到（次）'}]
            }
          ]
        };
        this.lab3Chart.setOption(option,true);
      },
      setLab3Data: function (_value1,_value2){
        this.lab3Chart.setOption({series: [{
            name:"今日达到（次）",
            data:[{value: _value1, name: '今日达到（次）'}]
          },{
            name:"累计达到（次）",
            data:[{value: _value2, name: '累计达到（次）'}]}
          ]
        });
      },
      setLab4Data: function (_data){
        let  lab4Chart0ption = {
          color: this.color,
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            data: [],
            textStyle:{
              color:'#07e1f1',
              fontSize:8
            },
            selectedMode:false,
            right:10,
            width:'20px',
            itemGap:5,
            padding:0,
            top:10,
            itemWidth:20
          },
          calculable : true,
          series : [
            {
              name:'地区分布',
              type:'pie',
              radius : '60%',
              center: ['40%', '50%'],
              label:{normal:{textStyle:{color: '#29b9d7'}}},
              data:[]
            }
          ]
        }
        lab4Chart0ption.legend.data = _data;
        lab4Chart0ption.series[0].data = _data;
        this.lab4Chart.setOption(lab4Chart0ption,true);
      },
      setLab5Data: function (_data){
        let lab5Chart0ption = {
          color: this.color,
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            data: [],
            textStyle:{
              color:'#07e1f1',
              fontSize:8
            },
            selectedMode:false,
            right:10,
            width:'20px',
            itemGap:5,
            padding:0,
            top:10,
            itemWidth:20
          },
          calculable : true,
          series : [
            {
              name:'分布',
              type:'pie',
              radius : ['40%','60%'],
              center: ['40%', '50%'],
              label:{normal:{textStyle:{color: '#29b9d7'}}},
              data:[]
            }
          ]
        }
        lab5Chart0ption.legend.data = _data;
        lab5Chart0ption.series[0].data = _data;
        this.lab5Chart.setOption(lab5Chart0ption,true);
      },
      setLab6Data: function (customerFlowData){
        let lab6Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          calculable : true,
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          xAxis : [{
            type : 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            data :customerFlowData.xaxisData
          }],
          yAxis : [{
            type : 'value',
            name:'(人)',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#57617B'
              }
            }
          }],
          series : [{
            name:'用户',
            type:'line',
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            areaStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgb(0,136,212)'
                }, {
                  offset: 0,
                  color: 'rgb(0,136,212)'
                }], false),
                shadowBlur: 5
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(0,136,212)',
                borderColor: 'rgba(0,136,212,0.2)',
                borderWidth: 12

              }
            },
            data:customerFlowData.yaxisData.activeData
          }]
        }
        this.lab6Chart.setOption(lab6Chart0ption,true);
      },
      setLab7Data: function (_data) {
        let lab7Chart0ption = {
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          calculable : true,
          series : [
            {
              name:'支付类型分布',
              type:'pie',
              radius : '60%',
              center: ['50%', '50%'],
              label:{normal:{textStyle:{color: '#29b9d7'}}},
              data:[]
            }
          ]
        }
        lab7Chart0ption.series[0].data = _data;
        this.lab7Chart.setOption(lab7Chart0ption, true);
      },
      lab8: function (){
        let option = {
          tooltip : {
            formatter: "{a} <br/>{b} : {c}%"
          },
          series : [
            {
              name:'充电',
              type:'gauge',
              center:['10%','50%'],
              title:{
                offsetCenter: [0, '60%'],
                textStyle: {
                  color: '#88fcfc',
                  fontSize : 18
                }
              },
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[0.2, '#88fcfc'],[0.8, '#409EFF'],[1, '#f1837a']],
                  width:5
                }
              },
              axisTick: {            // 坐标轴小标记
                length :5,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              splitLine:{
                length :5,
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              axisLabel:{
                show:false
              },
              pointer : {
                width : 2
              },
              detail : {
                formatter:'{value}%',
                offsetCenter: [0, 0],
                textStyle: {
                  color: 'auto',
                  fontSize : 24
                }
              },
              data:[{value: 50, name: '充电'}]
            },
            {
              name:'待机',
              type:'gauge',
              splitNumber: 10,
              center:['30%','50%'],
              title:{
                offsetCenter: [0, '60%'],
                textStyle: {
                  color: '#88fcfc',
                  fontSize : 18
                }
              },
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[0.2, '#88fcfc'],[0.8, '#409EFF'],[1, '#f1837a']],
                  width:5
                }
              },
              axisTick: {            // 坐标轴小标记
                splitNumber: 10,   // 每份split细分多少段
                length :5,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              splitLine:{
                length :5,
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              axisLabel:{
                show:false
              },
              pointer : {
                width : 2
              },
              detail : {
                formatter:'{value}%',
                offsetCenter: [0,0],
                textStyle: {
                  color: 'auto',
                  fontSize : 24
                }
              },
              data:[{value: 50, name: '待机'}]
            },
            {
              name:'总数',
              type:'gauge',
              center:['50%','50%'],
              startAngle:0,
              endAngle:359,
              title:{
                offsetCenter: [0, '50%'],
                textStyle: {
                  color: '#88fcfc',
                  fontSize : 18
                }
              },
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[0.4, '#88fcfc'],[0.8, '#409EFF'],[1, '#f1837a']],
                  width:6
                }
              },
              axisTick: {            // 坐标轴小标记
                length :5,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              splitLine:{
                length :6,
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              axisLabel:{
                show:false
              },
              pointer : {
                width : 0
              },
              detail : {
                formatter:'{value}',
                offsetCenter: [0, 0],
                textStyle: {
                  color: 'auto',
                  fontSize : 30,
                  fontWeight:'bold'
                }
              },
              data:[{value: 167757, name: '总数'}]
            },
            {
              name:'故障',
              type:'gauge',
              splitNumber: 10,
              center:['90%','50%'],
              title:{
                offsetCenter: [0, '60%'],
                textStyle: {
                  color: '#88fcfc',
                  fontSize : 18
                }
              },
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[0.2, '#88fcfc'],[0.8, '#409EFF'],[1, '#f1837a']],
                  width:5
                }
              },
              axisTick: {            // 坐标轴小标记
                splitNumber: 10,   // 每份split细分多少段
                length :5,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              splitLine:{
                length :5,
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              axisLabel:{
                show:false
              },
              pointer : {
                width : 2
              },
              detail : {
                formatter:'{value}%',
                offsetCenter: [0,0],
                textStyle: {
                  color: 'auto',
                  fontSize : 24
                }
              },
              data:[{value: 10, name: '故障'}]
            },
            {
              name:'维修',
              type:'gauge',
              splitNumber: 10,
              center:['70%','50%'],
              title:{
                offsetCenter: [0, '60%'],
                textStyle: {
                  color: '#88fcfc',
                  fontSize : 18
                }
              },
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[0.2, '#88fcfc'],[0.8, '#409EFF'],[1, '#f1837a']],
                  width:5
                }
              },
              axisTick: {            // 坐标轴小标记
                splitNumber: 10,   // 每份split细分多少段
                length :5,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              splitLine:{
                length :5,
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              axisLabel:{
                show:false
              },
              pointer : {
                width : 2
              },
              detail : {
                formatter:'{value}%',
                offsetCenter: [0,0],
                textStyle: {
                  color: 'auto',
                  fontSize : 24
                }
              },
              data:[{value: 10, name: '维修'}]
            }
          ]
        };
        this.lab8Chart.setOption(option,true);
      },
      setLab8Data: function (_value1,_value2,_value3,_value4,_value5){
        this.lab8Chart.setOption({series: [
            {
              name:"充电",
              data:[{value: _value1, name: '充电'}]
            },{
              name:"待机",
              data:[{value: _value2, name: '待机'}]
            },{
              name:"总数",
              data:[{value: _value3, name: '总数'}]
            },{
              name:"离线",
              data:[{value: _value4, name: '离线'}]
            },{
              name:"故障",
              data:[{value: _value5, name: '故障'}]
            }
          ]
        });
      },
      setLab9Data: function (customerFlowData){
        let lab9Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data:['总客户数','新增客户数'],
            x: 'center',
            textStyle:{color:"#29b9d7"}
          },
          calculable : true,
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          xAxis : [{
            type : 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            data : customerFlowData.xaxisData
          }],
          yAxis : [{
            name:'(个)',
            type : 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#57617B'
              }
            }
          }],
          series : [{
            name:'总客户数',
            type:'line',
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(0,136,212)',
                borderColor: 'rgba(0,136,212,0.2)',
                borderWidth: 12

              }
            },
            data:customerFlowData.yaxisData.totalData
          },{
            name:'新增客户数',
            type:'line',
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(221, 197, 95)',
                borderColor: 'rgba(221, 197, 95,0.27)',
                borderWidth: 12

              }
            },
            data:customerFlowData.yaxisData.growData
          }]
        }
        this.lab9Chart.setOption(lab9Chart0ption,true);
      },
      setLab10Data: function (dailyStationGroupList){
        let dayData = []
        let totalElectricityGroup = []
        let totalFeeGroup = []
        let totalFeeCustomer = []
        let totalElectricityCustomer = []
        for (let index in dailyStationGroupList) {
          dayData[index] = dailyStationGroupList[index].batchTime;
          totalElectricityGroup[index] = dailyStationGroupList[index].groupElectricQuantity;
          totalFeeGroup[index] = dailyStationGroupList[index].groupFee;
          totalElectricityCustomer[index] = dailyStationGroupList[index].stationElectricQuantity;
          totalFeeCustomer[index] = dailyStationGroupList[index].stationFee;
        }
        let lab10Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data: ['总营业额', '总充电量', '集团营业额', '集团充电量'],
            x: 'right',
            textStyle:{color:"#29b9d7"}
          },
          calculable : true,
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable: true,
          xAxis: {
            name:'日',
            type : 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            data: dayData
          },
          yAxis: [{
            type: 'value',
            name: '(kWh)',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#57617B'
              }
            }
          }],
          series: [
            {
              name: '总营业额',
              type: 'bar',
              data: totalFeeCustomer
            },
            {
              name: '总充电量',
              type: 'bar',
              data: totalElectricityCustomer
            },
            {
              name: '集团营业额',
              type: 'bar',
              data: totalFeeGroup
            },
            {
              name: '集团充电量',
              type: 'bar',
              data: totalElectricityGroup
            }
          ]
        }
        this.lab10Chart.setOption(lab10Chart0ption,true);
      },
      setLab11Data: function (chargeAnalyseStatistic){
        let lab11Chart0ption = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['尖电量', '峰电量', '平电量', '谷电量'],
            x: 'center',
            textStyle:{color:"#29b9d7"}
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable: true,
          xAxis: {
            name:'时',
            type : 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            data: chargeAnalyseStatistic.xaxisData
          },
          yAxis: [{
            type: 'value',
            name: '(kWh)',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#57617B'
              }
            }
          }],
          series: [
            {
              name: '尖电量',
              barWidth: 15,
              type: 'bar',
              data: chargeAnalyseStatistic.yaxisData.sharpElecData
            },
            {
              name: '峰电量',
              barWidth: 15,
              type: 'bar',
              data: chargeAnalyseStatistic.yaxisData.peakElecData
            },
            {
              name: '平电量',
              barWidth: 15,
              type: 'bar',
              data: chargeAnalyseStatistic.yaxisData.flatElecData
            },
            {
              name: '谷电量',
              barWidth: 15,
              type: 'bar',
              data: chargeAnalyseStatistic.yaxisData.valleyElecData
            }
          ]
        }
        this.lab11Chart.setOption(lab11Chart0ption,true);
      },
      setLab13Data: function (_data){
        let  lab13Chart0ption = {
          color: this.color,
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            data: [],
            textStyle:{
              color:'#07e1f1',
              fontSize:8
            },
            selectedMode:false,
            right:10,
            width:'20px',
            itemGap:5,
            padding:0,
            top:10,
            itemWidth:20
          },
          calculable : true,
          series : [
            {
              name:'访问来源',
              type:'pie',
              radius : '60%',
              center: ['40%', '50%'],
              label:{normal:{textStyle:{color: '#29b9d7'}}},
              data:[]
            }
          ]
        }
        lab13Chart0ption.legend.data = _data;
        lab13Chart0ption.series[0].data = _data;
        this.lab13Chart.setOption(lab13Chart0ption,true);
      },
      setLab14Data: function (chargeAnalyseStatistic){
        let  lab14Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data: ['充电次数','App','微信公众号','微信小程序','支付宝小程序','刷卡','互联互通'],
            x: 'center',
            textStyle:{color:"#29b9d7"}
          },
          calculable : true,
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          xAxis: {
            type : 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            data: chargeAnalyseStatistic.xaxisData
          },
          yAxis: {
            name:'(次数)',
            type : 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#57617B'
              }
            }
          },
          series: [
            {
              name: '充电次数',
              barWidth: 15,
              type: 'line',
              data: chargeAnalyseStatistic.yaxisData.chargeTimes
            },
            {
              name: 'App',
              barWidth: 15,
              type: 'line',
              data: chargeAnalyseStatistic.yaxisData.appData
            },{
              name: '微信公众号',
              barWidth: 15,
              type: 'line',
              data: chargeAnalyseStatistic.yaxisData.weixinData
            },{
              name: '微信小程序',
              barWidth: 15,
              type: 'line',
              data: chargeAnalyseStatistic.yaxisData.weixinXcxData
            },{
              name: '支付宝小程序',
              barWidth: 15,
              type: 'line',
              data: chargeAnalyseStatistic.yaxisData.aliXcxData
            },{
              name: '刷卡',
              barWidth: 15,
              type: 'line',
              data: chargeAnalyseStatistic.yaxisData.terminalData
            },{
              name: '互联互通',
              barWidth: 15,
              type: 'line',
              data: chargeAnalyseStatistic.yaxisData.cecData
            }
          ]
        }
        this.lab14Chart.setOption(lab14Chart0ption,true);
      },
      setLab15Data: function (_data){
        let  lab15Chart0ption = {
          color: this.color,
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            data: [],
            textStyle:{
              color:'#07e1f1',
              fontSize:8
            },
            selectedMode:false,
            right:10,
            width:'20px',
            itemGap:5,
            padding:0,
            top:10,
            itemWidth:20
          },
          calculable : true,
          series : [
            {
              name:'分布',
              type:'pie',
              radius : '60%',
              center: ['50%', '50%'],
              label:{normal:{textStyle:{color: '#29b9d7'}}},
              data:[]
            }
          ]
        }
        lab15Chart0ption.legend.data = _data;
        lab15Chart0ption.series[0].data = _data;
        this.lab15Chart.setOption(lab15Chart0ption,true);
      },
      setLabtopChart: function (_data){
        let  labtopChart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: 42,
            bottom: '3%',
            top:'3%',
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'value',
            name:'千人',
            axisLabel:{
              textStyle:{
                color:'#29b9d7',
                fontSize:12
              },
            },
            axisLine:{
              lineStyle:{
                color: '#29b9d7',
                width:0,type: 'solid'
              }
            },
            splitLine:{show:false}
          }],
          yAxis : [{
            type : 'category',
            data : [],
            axisLine:{
              lineStyle:{
                color: '#29b9d7',
                width:0,
                type: 'solid'
              }
            },
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: false,
            }
          }],
          series : [
            {
              name:'用户数',
              type:'bar',
              itemStyle:{
                normal:{
                  color:'#3287f0',
                }
              },
              barWidth:10,
              data:[]
            }
          ]
        }
        let _yMonth=[],_val=[];
        _data.forEach(function(v){
          _yMonth.push(v.name);
          _val.push(v.value);
        });
        labtopChart0ption.yAxis[0].data = _yMonth;
        labtopChart0ption.series[0].data = _val;
        this.labtopChart.setOption(labtopChart0ption,true);
      },
      setLab16Data: function (_data){
        let  lab16Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: 42,
            bottom: '3%',
            top:'3%',
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'value',
            name:'千kWh',
            axisLabel:{
              textStyle:{
                color:'#29b9d7',
                fontSize:12
              },
            },
            axisLine:{
              lineStyle:{
                color: '#29b9d7',
                width:0,type: 'solid'
              }
            },
            splitLine:{show:false}
          }],
          yAxis : [{
            type : 'category',
            data : [],
            axisLine:{
              lineStyle:{
                color: '#29b9d7',
                width:0,
                type: 'solid'
              }
            },
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: false,
            }
          }],
          series : [
            {
              name:'充电量',
              type:'bar',
              itemStyle:{
                normal:{
                  color:'#3287f0',
                }
              },
              barWidth:10,
              data:[]
            }
          ]
        }
        let _yMonth=[],_val=[];
        _data.forEach(function(v){
          _yMonth.push(v.name);
          _val.push(v.value);
        });
        lab16Chart0ption.yAxis[0].data = _yMonth;
        lab16Chart0ption.series[0].data = _val;
        this.lab16Chart.setOption(lab16Chart0ption,true);
      },
      lab17: function (){
        let heatData = [{
          "name": "车辆1",
          "value": [107.615944, 27.479744, 2]
        },
          {
            "name": "车辆2",
            "value": [108.296644, 27.676476, 2]
          },
          {
            "name": "车辆3",
            "value": [109.296644, 27.876476, 2]
          }];
        var heatData1 = [{
          "name": "车辆1",
          "value": [110.615944, 27.479744, 2]
        },
          {
            "name": "车辆2",
            "value": [108.296644, 26.676476, 2]
          },
          {
            "name": "车辆3",
            "value": [110.296644, 28.876476, 2]
          }];
        let  lab17Chart0ption = {
          timeline:{
            axisType: 'category',
            data:['2018','2019','2020','2021','2022'],
            label : {
              textStyle:{color:"#88fcfc"}
            },
            lineStyle:{
              color: '#88fcfc',
            },
            checkpointStyle:{
              color:'#88fcfc',
              borderColor:'#88fcfc'
            },
            controlStyle:{
              normal : {
                color : '#88fcfc'
              },
              emphasis : {
                color : '#88fcfc'
              }
            },
            autoPlay : true,
            playInterval : 3000
          },options:[{
            tooltip: {
              show: true,
              trigger: 'item',
              triggerOn: 'click',
              formatter: "名称:{b}<br />坐标:{c}"
            },
            visualMap: {
              show: false,
              top: 'top',
              min: 0,
              max: 5,
              seriesIndex: 0,
              calculable: true,
              inRange: {
                color: [ "rgba(12, 143, 233, 0.5)"]
              }
            },
            series: [
              {
                name: "充电桩按年统计",
                type: 'map',
                mapType: 'china',
                itemStyle:{
                  normal: {
                    borderColor:"#00cbfe",
                    areaColor:'rgba(12, 143, 233, 0.5)',
                    label:{
                      show:true,
                      textStyle: {
                        color: "#ffffff"
                      }
                    }
                  },
                  emphasis:{
                    borderColor:"#00cbfe",
                    areaColor:'#0193e9',
                    label:{
                      show:true,
                      textStyle: {
                        color: "#ffffff"
                      }
                    }
                  }
                },
                showLegendSymbol: true,
                label: {
                  normal: {
                    show: false //不显示省份名称
                  },
                  emphasis: {
                    show: true
                  }
                },
                data: []
              }
            ]
          },{
            series:[{data:heatData1}]
          },{
            series:[{data:heatData}]
          },{
            series:[{data:heatData1}]
          },{
            series:[{data:heatData}]
          }]
        };
        this.lab17Chart.setOption(lab17Chart0ption);
      },
      setCity17Data: function (_cityData){
        this.lab17Chart.setOption({series: [{
            name: '充电桩按年统计',
            data:_cityData
          }]});
      },
      setCity19Data: function (_data,_data2){
        let  lab19Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data:['充电站（个）', '充电桩（百个）'],
            x:'center',
            textStyle:{color:"#88fcfc"}
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'category',
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize:12},
            },
            axisLine:{lineStyle:{color: '#29b9d7',width:0,type: 'solid'}},
            data : []
          }],
          yAxis : [{
            type : 'value',
            axisLine:{lineStyle:{color: '#29b9d7',width:0,type: 'solid'}},
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: true,
              lineStyle:{color: '#57617B'}
            }
          }],
          series : [
            {
              name:'充电站（个）',
              type:'bar',
              itemStyle:{
                normal:{
                  color: '#3287f0',
                }
              },
              barWidth:10,
              data:[]
            },
            {
              name:'充电桩（百个）',
              type:'bar',
              itemStyle:{
                normal:{
                  color: '#ceffa6',
                }
              },
              barWidth:10,
              data:[]
            }
          ]
        }
        let _xMonth=[],_val=[];
        let _val2 = [];
        _data.forEach(function(v){
          _xMonth.push(v.name);
          _val.push(v.value);
        });
        _data2.forEach(function(v){
          _val2.push(v.value);
        });
        lab19Chart0ption.xAxis[0].data = _xMonth;
        lab19Chart0ption.series[0].data = _val;
        lab19Chart0ption.series[1].data = _val2;
        this.lab19Chart.setOption(lab19Chart0ption,true);
      },
      setCity20Data: function (_data,_data2){
        let  lab20Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data:['充电量（亿千瓦时）', '充电负荷（万千瓦时）'],
            x:'center',
            textStyle:{color:"#29b9d7"}
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            data : []
          }],
          yAxis : [{
            type : 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#57617B'
              }
            }
          },{
            type : 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#29b9d7'
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color:'#29b9d7'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#57617B'
              }
            }
          }],
          series : [
            {
              name:'充电量（亿千瓦时）',
              type:'line',
              yAxisIndex:0,
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 1
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgb(0,136,212)',
                  borderColor: 'rgba(0,136,212,0.2)',
                  borderWidth: 12

                }
              },
              data:[]
            },
            {
              name:'充电负荷（万千瓦时）',
              type:'line',
              yAxisIndex:1,
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 1
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgb(221, 197, 95)',
                  borderColor: 'rgba(221, 197, 95,0.27)',
                  borderWidth: 12

                }
              },
              data:[]
            }
          ]
        }
        let _xMonth=[],_val=[];
        let _val2 = [];
        _data.forEach(function(v){
          _xMonth.push(v.name);
          _val.push(v.value);
        });
        _data2.forEach(function(v){
          _val2.push(v.value);
        });
        lab20Chart0ption.xAxis[0].data = _xMonth;
        lab20Chart0ption.series[0].data = _val;
        lab20Chart0ption.series[1].data = _val2;
        this.lab20Chart.setOption(lab20Chart0ption,true);
      },
      setCity21Data: function (dailyOrderList){
        let xdata = []
        let ydataFee = []
        let ydataElectricity = []
        for (let i = 0; i < dailyOrderList.length; i++) {
          xdata[i] = dailyOrderList[i].batchTime
          ydataFee[i] = dailyOrderList[i].totalFee
          ydataElectricity[i] = dailyOrderList[i].totalElectricQuantity
        }
        let  lab21Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data:['充电量', '充电金额'],
            x:'center',
            textStyle:{color:"#88fcfc"}
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'category',
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize:12},
            },
            axisLine:{lineStyle:{color: '#29b9d7',width:1,type: 'solid'}},
            data : xdata
          }],
          yAxis : [{
            type : 'value',
            name:'(元)',
            axisLine:{lineStyle:{color: '#29b9d7',width:1,type: 'solid'}},
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: true,
              lineStyle:{color: '#57617B'}
            }
          },{
            type : 'value',
            name:'(kWh)',
            axisLine:{lineStyle:{color: '#29b9d7',width:1,type: 'solid'}},
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: true,
              lineStyle:{color: '#57617B'}
            }
          }],
          series : [
            {
              name:'充电量',
              type:'bar',
              yAxisIndex:1,
              itemStyle:{
                normal:{
                  color: '#3287f0',
                }
              },
              barWidth:10,
              data:ydataElectricity
            },
            {
              name:'充电金额',
              type:'line',
              yAxisIndex:0,
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 1
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgb(221, 197, 95)',
                  borderColor: 'rgba(221, 197, 95,0.27)',
                  borderWidth: 12

                }
              },
              data:ydataFee
            }
          ]
        }
        this.lab21Chart.setOption(lab21Chart0ption,true);
      },
      setCity22Data: function (_data,_data2){
        let  lab22Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data:['充电站（个）', '充电桩（百个）'],
            x:'center',
            textStyle:{color:"#88fcfc"}
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'category',
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize:12},
            },
            axisLine:{lineStyle:{color: '#29b9d7',width:0,type: 'solid'}},
            data : []
          }],
          yAxis : [{
            type : 'value',
            axisLine:{lineStyle:{color: '#29b9d7',width:0,type: 'solid'}},
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: true,
              lineStyle:{color: '#57617B'}
            }
          }],
          series : [
            {
              name:'充电站（个）',
              type:'bar',
              itemStyle:{
                normal:{
                  color: '#3287f0',
                }
              },
              barWidth:10,
              data:[]
            },
            {
              name:'充电桩（百个）',
              type:'bar',
              itemStyle:{
                normal:{
                  color: '#ceffa6',
                }
              },
              barWidth:10,
              data:[]
            }
          ]
        }
        let _xMonth=[],_val=[];
        let _val2 = [];
        _data.forEach(function(v){
          _xMonth.push(v.name);
          _val.push(v.value);
        });
        _data2.forEach(function(v){
          _val2.push(v.value);
        });
        lab22Chart0ption.xAxis[0].data = _xMonth;
        lab22Chart0ption.series[0].data = _val;
        lab22Chart0ption.series[1].data = _val2;
        this.lab22Chart.setOption(lab22Chart0ption,true);
      },
      setCity23Data: function (_data,_data2){
        let  lab23Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data:['拉动电动汽车动力电池产量（万个）', '拉动电动汽车产值（万辆）'],
            x:'center',
            textStyle:{color:"#88fcfc"}
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'category',
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize:12},
            },
            axisLine:{lineStyle:{color: '#29b9d7',width:1,type: 'solid'}},
            data : []
          }],
          yAxis : [{
            type : 'value',
            axisLine:{lineStyle:{color: '#29b9d7',width:1,type: 'solid'}},
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: true,
              lineStyle:{color: '#57617B'}
            }
          }],
          series : [
            {
              name:'拉动电动汽车动力电池产量（万个）',
              type:'line',
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 1
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgb(0,136,212)',
                  borderColor: 'rgba(0,136,212,0.2)',
                  borderWidth: 12

                }
              },
              data:[]
            },
            {
              name:'拉动电动汽车产值（万辆）',
              type:'line',
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 1
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgb(221, 197, 95)',
                  borderColor: 'rgba(221, 197, 95,0.27)',
                  borderWidth: 12

                }
              },
              data:[]
            }
          ]
        }
        let _xMonth=[],_val=[];
        let _val2 = [];
        _data.forEach(function(v){
          _xMonth.push(v.name);
          _val.push(v.value);
        });
        _data2.forEach(function(v){
          _val2.push(v.value);
        });
        lab23Chart0ption.xAxis[0].data = _xMonth;
        lab23Chart0ption.series[0].data = _val;
        lab23Chart0ption.series[1].data = _val2;
        this.lab23Chart.setOption(lab23Chart0ption,true);
      },
      setCity24Data: function (_data){
        let  lab24Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: 50,
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'category',
            name:'月份',
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize:12},
            },
            axisLine:{lineStyle:{color: '#29b9d7',width:0,type: 'solid'}},
            data : []
          }],
          yAxis : [{
            type : 'value',
            name:'(个)',
            axisLine:{lineStyle:{color: '#29b9d7',width:0,type: 'solid'}},
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: true,
              lineStyle:{color: '#57617B'}
            }
          }],
          series : [
            {
              name:'故障数',
              type:'bar',
              itemStyle:{
                normal:{
                  color:'#ceffa6',
                }
              },
              barWidth:10,
              data:[]
            }
          ]
        }
        let _xMonth=[],_val=[];
        _data.forEach(function(v){
          _xMonth.push(v.name);
          _val.push(v.value);
        });
        lab24Chart0ption.xAxis[0].data = _xMonth;
        lab24Chart0ption.series[0].data = _val;
        this.lab24Chart.setOption(lab24Chart0ption,true);
      },
      setCity25Data: function (_data){
        let  lab25Chart0ption = {
          color: this.color,
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            data: [],
            textStyle:{
              color:'#07e1f1',
              fontSize:8
            },
            selectedMode:false,
            right:10,
            width:'20px',
            itemGap:5,
            padding:0,
            top:10,
            itemWidth:20
          },
          calculable : true,
          series : [
            {
              name:'地区分布',
              type:'pie',
              radius : '60%',
              center: ['40%', '50%'],
              label:{normal:{textStyle:{color: '#29b9d7'}}},
              data:[]
            }
          ]
        }
        lab25Chart0ption.legend.data = _data;
        lab25Chart0ption.series[0].data = _data;
        this.lab25Chart.setOption(lab25Chart0ption,true);
      },
      setCity26Data: function (_data,_data2){
        let  lab26Chart0ption = {
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data:['二氧化碳（万吨）', '一氧化碳（万吨）'],
            x:'center',
            textStyle:{color:"#88fcfc"}
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          calculable : true,
          xAxis : [{
            type : 'category',
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize:12},
            },
            axisLine:{lineStyle:{color: '#29b9d7',width:1,type: 'solid'}},
            data : []
          }],
          yAxis : [{
            type : 'value',
            axisLine:{lineStyle:{color: '#29b9d7',width:1,type: 'solid'}},
            axisLabel:{
              textStyle:{color:'#29b9d7',fontSize: 12},
            },
            splitLine: {
              show: true,
              lineStyle:{color: '#57617B'}
            }
          }],
          series : [
            {
              name:'二氧化碳（万吨）',
              type:'line',
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 1
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgb(0,136,212)',
                  borderColor: 'rgba(0,136,212,0.2)',
                  borderWidth: 12

                }
              },
              data:[]
            },
            {
              name:'一氧化碳（万吨）',
              type:'line',
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 1
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgb(221, 197, 95)',
                  borderColor: 'rgba(221, 197, 95,0.27)',
                  borderWidth: 12

                }
              },
              data:[]
            }
          ]
        }
        let _xMonth=[],_val=[];
        let _val2 = [];
        _data.forEach(function(v){
          _xMonth.push(v.name);
          _val.push(v.value);
        });
        _data2.forEach(function(v){
          _val2.push(v.value);
        });
        lab26Chart0ption.xAxis[0].data = _xMonth;
        lab26Chart0ption.series[0].data = _val;
        lab26Chart0ption.series[1].data = _val2;
        this.lab26Chart.setOption(lab26Chart0ption,true);
      },
      setCity27Data: function (_data){
        let  lab27Chart0ption = {
          color: this.color,
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            data: [],
            textStyle:{
              color:'#07e1f1',
              fontSize:8
            },
            selectedMode:false,
            right:10,
            width:'20px',
            itemGap:5,
            padding:0,
            top:10,
            itemWidth:20
          },
          calculable : true,
          series : [
            {
              name:'有量预测',
              type:'pie',
              radius : '60%',
              center: ['40%', '50%'],
              label:{normal:{textStyle:{color: '#29b9d7'}}},
              data:[]
            }
          ]
        }
        lab27Chart0ption.legend.data = _data;
        lab27Chart0ption.series[0].data = _data;
        this.lab27Chart.setOption(lab27Chart0ption,true);
      },
      citySwitch: function (){
        $(".form-city-arr").slideToggle("slow");
      },
      rowArr: function (_mapName){
        $(".form-city-arr").slideToggle("hide");
        $(".map-text").html(_mapName);
        this.mapchart.setOption({geo:{map:_mapName}});
        this.lab17Chart.setOption({geo:{map:_mapName}});
      },
      setnumber: function (name,number){
        let final_arr = this.number(number);
        $("."+name).html(this.dom(final_arr,name));
        this.boxanimation(name);
      },
      number: function(digit){
        let num_arr=[];
        for(let i = 0;i<digit.length;i++){
          num_arr.push(digit.charAt(i));
        }
        return num_arr;
      },
      dom: function(arr,name){
        let str = '';
        for(let i = 0;i<arr.length;i++){
          if(parseInt(arr[i])>=0){
            str += '<div class="l js-l-'+name+'" data-show='+arr[i]+'>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">0</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">1</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">2</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">3</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">4</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">5</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">6</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">7</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">8</span>\
                  <span style="display: inline-block;color: #fff;width: 40px;height: 40px;font-size: 40px;line-height: 40px;background-color: rgba(30, 126, 201, 0.35);margin-left: 2px;">9</span>\
                </div>';
          }else{
            str += '<div class="sign-box l"><span>'+arr[i]+'</span></div>';
          }
        }
        return str;
      },
      boxanimation: function(name){
        let height =$('.'+name).height();
        let experts = $(".js-l-"+name);
        for(let i=0;i<experts.length;i++){
          let expert = experts[i];
          let num = parseInt($(expert).data("show"));
          let scrollTop = height * num;
          $(expert).css("margin-top",0);
          $(expert).css("width",'40px');
          $(expert).css("text-align",'center');
          $(expert).css("overflow",'hidden');
          $(expert).css("font-size",'0');
          $(expert).css("float",'left');
          $(expert).animate({'marginTop': -scrollTop},1500);
        }
        let width = $("."+name).width()/2;
        $('.'+name).css('margin-left','-'+width+'px');
      },
      random: function (min, max) {
        if (arguments.length < 2) {
          max = min;
          min = 0;
        }

        if (min > max) {
          var hold = max;
          max = min;
          min = hold;
        }

        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      maxOrbit: function (x, y) {
        var max = Math.max(x, y),
          diameter = Math.round(Math.sqrt(max * max + max * max));
        return diameter / 2;
        //星星移动范围，值越大范围越小，
      },
      star: function() {
        let obj = {
          orbitRadius: 0,
          radius: 0,
          orbitX: 0,
          orbitY: 0,
          timePassed: 0,
          speed: 0,
          alpha: 0
        };
        obj.orbitRadius = this.random(this.maxOrbit(this.w, this.h));
        obj.radius = this.random(100, obj.orbitRadius) / 4;
        //星星大小
        obj.orbitX = this.w / 2;
        obj.orbitY = this.h / 2;
        obj.timePassed = this.random(0, this.maxStars);
        obj.speed = this.random(obj.orbitRadius) / 20000;
        //星星移动速度
        obj.alpha = this.random(2, 10) / 10;
        this.stars.push(obj);
      },
      draw: function(star,ctx) {
        let x = Math.sin(star.timePassed) * star.orbitRadius + star.orbitX,
          y = Math.cos(star.timePassed) * star.orbitRadius + star.orbitY,
          twinkle = this.random(10);

        if (twinkle === 1 && star.alpha > 0) {
          star.alpha -= 0.05;
        } else if (twinkle === 2 && star.alpha < 1) {
          star.alpha += 0.05;
        }

        ctx.globalAlpha = star.alpha;
        ctx.drawImage(this.canvas2, x - star.radius / 2, y - star.radius / 2, star.radius, star.radius);
        star.timePassed += star.speed;
      },
      PrefixInteger(num, length) {
        return (Array(length).join('0') + num).slice(-length);
      },
      initialization: function () {
        //this.setCityData(mapCityData);
        this.initmap();
        //活跃用户比
        setTimeout(() => {
          var _value = (this.order.dailyOrder.orderNum/this.member.customerNum).toFixed(2);
          this.setLab2Data(_value);
        }, 2000)

        //今日达到次数和累计达到次数
        setTimeout(() => {
          let _jrddNum = (this.order.dailyOrder.orderNum).toFixed(0);//今日达到
          let _ljddNum = (this.order.totalOrder.orderNum).toFixed(0);//累计达到
          this.setLab3Data(_jrddNum,_ljddNum);
        },2000);
        this.getStationVisualGroupAddress('')
        this.getStationVisualChargeAddress('')

        //充电桩数量、在线率和故障
        this.getChargeAnalyseData();
        this.getAnalyseData();
        this.getStationOrder();
        this.getGunRealTimeStatistics();
        this.getOrderStatisticsV2();
        this.getOperatorStationRanking();
        this.getRingStatistics();

        //扩展应用 热地图
        this.setCity17Data(mapCityData);

        //全省分区域充电设施预测
        this.setCity19Data(json19.liang,json19.number);

        //充电汽车充电量及充电负荷测算
        this.setCity20Data(json20.liang,json20.number);

        //电动汽车充电设施及建设规模
        this.setCity22Data(json20.liang,json20.number);

        //拉动电动汽车及动力电池产值预算
        this.setCity23Data(json20.liang,json20.number);

        //近12月故障数
        //this.setCity24Data(json24.data);



        //充电汽车节能排除故障
        this.setCity26Data(json20.liang,json20.number);


        console.info(JSON.stringify(this.res.res))
        this.setnumber('number1',this.res.res.pileNum+ '');
        this.setnumber('number2',this.res.res.totalPower+ '');
        this.setnumber('number3',Math.round(this.order.totalOrder.totalElectricity)+ '');
        this.setnumber('number4',Math.round(this.order.dailyOrder.totalElectricity)+ '');
        this.setnumber('number5',this.order.dailyOrder.orderNum+ '');
        this.setnumber('number6',this.order.totalOrder.orderNum+ '');
        var now = new Date()
        var target = new Date('2020/5/18') //元旦的时间
        var d = now.getTime() - target.getTime()
        var d2 = target-now //两种方法一样的
        //两个对象直接相减得到的就是相差毫秒数
        d=Math.floor(d/1000) //将毫秒转化为秒
        //获取相差的天数，除以一天的秒数,向下取整
        var day =Math.floor(d/(24*60*60))
        this.setnumber('number7',day+ '');
      },
      compareDesc (prop) {
        return function (obj1, obj2) {
          var val1 = obj1[prop];
          var val2 = obj2[prop];
          if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
          }
          if (val1 > val2) {
            return -1;
          } else if (val1 < val2) {
            return 1;
          } else {
            return 0;
          }
        }
      },
      compareAsc (prop) {
        return function (obj1, obj2) {
          var val1 = obj1[prop];
          var val2 = obj2[prop];
          if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
          }
          if (val1 < val2) {
            return -1;
          } else if (val1 > val2) {
            return 1;
          } else {
            return 0;
          }
        }
      },
      getStationVisualGroupAddress (operatorId) {
        dataVisualApi.getStationVisualGroupAddress(operatorId).then((res) => {
          if (res.code === 0) {
            let nodes =[]
            for(let item of res.data){
              nodes.push({name: item["city"],value: item["totalNum"]})
            }
            this.setLab4Data(nodes);
            //充电站分布
            this.setLab15Data(nodes);
          }
        })
      },
      getStationVisualChargeAddress (operatorId) {
        dataVisualApi.getStationVisualChargeAddress(operatorId).then((res) => {
          if (res.code === 0) {
            let nodes =[]
            for(var key in res.data){
              nodes.push({name: key,value: parseInt(res.data[key]["totalElectricity"])})
            }
            nodes = nodes.sort(this.compareAsc('value'))
            console.log(JSON.stringify(nodes));
            //设置xxx分布数据 若要随时间变化自行轮询
            this.setLab5Data(nodes);
            //支付服务
            this.setLab7Data(nodes);
            //意见反馈焦点总次数
            this.setLab13Data(nodes);
            this.setLabtopChart(nodes);
            //故障告知类型分布
            this.setCity25Data(nodes);
            //电动汽车保有量预测
            this.setCity27Data(nodes);
          }
        })
      },
      getChargeAnalyseData(parameter) {
        console.log(parameter);
        dataVisualApi.getChargeAnalyseData(parameter).then((res) => {
          if(res){
            this.setLab14Data(res);
            this.setLab11Data(res);
          }
        })
      },
      getAnalyseData(parameter){
        dataVisualApi.getAnalyseData(parameter).then((res) => {
          console.log(res);
          if(res){
            this.setLab6Data(res);
            this.setLab9Data(res);
          }
        })
      },
      getStationOrder(param) {
        dataVisualApi.getStationOrder(param).then((res) => {
          if (res) {
            //this.currentDayOrder = res.currentDayOrder
            //this.currentMonthOrder = res.currentMonthOrder
            //this.currentYearOrder = res.currentYearOrder
            //this.totalOrder = res.totalOrder
            //this.dailyStationGroupList = res.dailyStationGroupList
            this.setLab10Data(res.dailyStationGroupList);
            //this.dailyStationOrderList = res.dailyStationOrderList
            //this.pileOrdeMonthly = res.pileOrdeMonthly
            //this.utilization = Math.round(res.userRate /(this.stationGunHour.chargingGunNum+this.stationGunHour.freeGunNum)* 100)/100
          }
        })
      },
      getGunRealTimeStatistics(param) {
        dataVisualApi.getGunRealTimeStatistics(param).then((res) => {
          if (res) {
            let _CDNum = (res.gunRealTimeStatistics.chargingGunNum/res.selfStationStatistics.gunNum * 100).toFixed(2) - 0;//充电
            let _DJNum = (res.gunRealTimeStatistics.freeGunNum/res.selfStationStatistics.gunNum * 100).toFixed(2) - 0;//待机
            let _COUNTNum = res.selfStationStatistics.gunNum;	//总数
            let _LXNum = (res.gunRealTimeStatistics.offlineGunNum/res.selfStationStatistics.gunNum * 100).toFixed(2) - 0;//离线
            let _GZNum = (res.gunRealTimeStatistics.badGunNum/res.selfStationStatistics.gunNum * 100).toFixed(2) - 0;//故障
            this.setLab8Data(_CDNum,_DJNum,_COUNTNum,_LXNum,_GZNum);
          }
        });
      },
      getOrderStatisticsV2(param) {
        dataVisualApi.getOrderStatisticsV2(param).then((res) => {
          if (res) {
            //this.orderPart.currentDayData = res.currentDayData;
            this.currentMonthData = res.currentMonthData;
            this.beforeMonthData = res.beforeMonthData;
            //this.orderPart.currentYearData = res.currentYearData;
            //this.orderPart.groupMonthData = res.groupMonthData;
            //this.orderPart.chargeLength = second2Time(res.currentDayData.chargeLength);
            //this.orderPart.usedRate = (Math.round(res.currentDayData.chargeLength / (86400*(this.gunRealTimeStatistics.chargingGunNum+this.gunRealTimeStatistics.freeGunNum)) * 10000) / 100.00);
          }
        });
      },
      getOperatorStationRanking(param) {
        dataVisualApi.getOperatorStationRanking(param).then((res) => {
          if (res.code === 0) {
            let nodes =[]
            let index = 0
            for(let item of res.data.stationCurrentMonthRanking){
              nodes.push({name: item['stationName'],value: item['totalElectricQuantity']})
              index = index +1
              if(index == 5){
                break
              }
            }
            nodes = nodes.sort(this.compareAsc('value'))
            this.setLab16Data(nodes);
            //this.stationRanking.stationCurrentMonthTotal = res.data.stationCurrentMonthTotal;
          }else{
            console.log("充电概览及排行榜，数据获取异常");
          }
        });
      },
      getRingStatistics(operatorId) {
        dataVisualApi.getRingStatistics(operatorId).then((res) => {
          if (res) {
            this.order.orderSource = res.operatorOrder.orderSource
            this.order.currentMonthOrder = res.operatorOrder.currentMonthOrder
            this.getRing();
            this.setCity21Data(res.operatorOrder.dailyOrderList);
            /*this.member = res.operatorMember;
            this.ops = res.operatorOps;
            this.res = res.operatorRes*/
          }
        });
      },
      getRing() {
        let myMap = {}
        for (let i = 0; i < this.order.orderSource.length; i++) {
          if(myMap.hasOwnProperty(this.order.orderSource[i].orderSource)){
            myMap[this.order.orderSource[i].orderSource] =  myMap[this.order.orderSource[i].orderSource] + this.order.orderSource[i].orderNum
          }else{
            myMap[this.order.orderSource[i].orderSource] = this.order.orderSource[i].orderNum
          }
        }
        this.orderSourceMap = myMap
        let data = [0]
        let mapIndex = 0
        for (let key in myMap) {
          data[mapIndex] = {
            value:myMap[key],
            name:key
          }
          mapIndex = mapIndex + 1
        }
        let lab28Chart0ption = {
          tooltip: {
            trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '14',
                    fontWeight: 'bold'
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: data
            }
          ]
        }
        this.lab28Chart.setOption(lab28Chart0ption,true)
      },
    }
  }
</script>
<style scoped lang="scss">
  .main_div{
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif,'微软雅黑';
    margin: 0;
    height: 1080px;
    width: 5120px;
    color: #fff;
    background: -webkit-linear-gradient(45deg,#0a1c44 0%, #258ace 75%, #0a1c44 100%);
    background: -moz-linear-gradient(45deg, #0a1c44 0%, #258ace 75%, #0a1c44 100%);
    background: -o-linear-gradient(45deg, #0a1c44 0%, #258ace 75%, #0a1c44 100%);
    background: -ms-linear-gradient(45deg, #0a1c44 0%, #258ace 75%, #0a1c44 100%);
    background: linear-gradient(45deg, #0a1c44 0%, #258ace 75%, #0a1c44 100%);
    font-size: 16px;
    z-index: 999;
    position: relative;
  }
  .form-margin{
    padding: 10px;
    position: absolute;
    z-index: 99999;
    right: 10px;
    margin-top: 40px;
    left: 300px;
    display: none;
    background: -webkit-linear-gradient(45deg,#0a1c44 0%, #258ace 75%, #0a1c44 100%);
    background: -moz-linear-gradient(45deg, #0a1c44 0%, #258ace 75%, #0a1c44 100%);
    background: -o-linear-gradient(45deg, #0a1c44 0%, #258ace 75%, #0a1c44 100%);
    background: -ms-linear-gradient(45deg, #0a1c44 0%, #258ace 75%, #0a1c44 100%);
    background: linear-gradient(45deg, #0a1c44 0%, #258ace 75%, #0a1c44 100%);
  }
  .lb{
    width: 1900px;
    height: 1040px;
    float: left;
    margin-left: 30px;
    margin-top: 20px;
  }
  .center{
    float: left;
    width: 1200px;
    height: 1040px;
    margin-left: 30px;
    margin-top: 20px;
    position: relative;
  }
  .lb-top{
    height: 200px;
  }
  .lb-top li{
    float: left;
    z-index: 999;
    list-style: none;
    border: 4px solid rgba(30, 126, 201, 0.33);
    width: 459.5px;
    text-align: center;
    margin-bottom: 10px;
    margin-left: 10px;
    height: 95px;
    position: relative;
    font-size: 26px;
    padding-top: 15px;
    font-weight: bold;
  }
  .lb-top li:first-child{
    margin-left: 0px;
  }
  .lb-top .tis{
    float: left;
    /* border: 2px solid #068de6;
     border-image: -webkit-linear-gradient( #068de6, #0b53b5) 30 30;
     border-image: -moz-linear-gradient( #068de6, #0b53b5) 30 30;
     border-image: linear-gradient( #068de6, #0b53b5) 30 30;*/
    border: 4px solid rgba(30, 126, 201, 0.33);
    width: 937px;
    margin-left: 10px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    z-index: 999;
    position: relative;
    -moz-box-shadow: 1px 1px 10px #0c3253 inset;
    -webkit-box-shadow: 1px 1px 10px #0c3253 inset;
    box-shadow: 1px 1px 10px #0c3253 inset;
  }
  .tis span{
    padding: 0 40px;
  }
  .logo{
    font-weight: bold;
    color: #65bdc1;
    text-align: center;
    line-height: 105px;
    height: 140px;
    font-size: 45px;
  }
  .center-top li{
    border: 4px solid #0c3253;
    width: 277px;
    float: left;
    height: 80px;
    line-height: 40px;
    margin-left: 20px;
    list-style: none;
    text-align: center;
    font-weight: bold;
    font-size: 1.2rem;
    z-index: 999;
    position: relative;
  }
  .center-top li p{
    color: #88fcfc;
    margin: 0;
    line-height: 30px;
    font-weight: 100;
    font-size: 40px;
  }
  .lb-center li{
    height: 200px;
    margin-top: 10px;
    list-style: none;
  }
  .lb-center li div{
    float: left;
    position: relative;
    z-index: 1;
    -moz-box-shadow: 1px 1px 10px #0c3253 inset;
    -webkit-box-shadow: 1px 1px 10px #0c3253 inset;
    box-shadow: 1px 1px 10px #0c3253 inset;
  }
  .icon-top:before {
    content: '';
    background: url(../images/topleft.png) no-repeat;
    width: 40px;
    height: 19px;
    left: 0;
    top: 0;
    position: absolute;
  }
  .icon-top:after {
    content: '';
    background: url(../images/topright.png) no-repeat;
    width: 40px;
    height: 19px;
    right: 0;
    top: 0;
    position: absolute;
  }
  .icon-bottom:before {
    content: '';
    background: url(../images/leftbottom.png) no-repeat;
    width: 40px;
    height: 19px;
    left: 0;
    bottom: 0;
    position: absolute;
  }
  .icon-bottom:after {
    content: '';
    background: url(../images/rightbottom.png) no-repeat;
    width: 40px;
    height: 19px;
    right: 0;
    bottom: 0;
    position: absolute;
  }
  .icon-top-head:before {
    content: '';
    background: url(../images/topleft.png) no-repeat;
    width: 40px;
    height: 19px;
    left: -4px;
    top: -4px;
    position: absolute;
  }
  .icon-top-head:after {
    content: '';
    background: url(../images/topright.png) no-repeat;
    width: 40px;
    height: 19px;
    right: -4px;
    top: -4px;
    position: absolute;
  }
  .icon-bottom-head:before {
    content: '';
    background: url(../images/leftbottom.png) no-repeat;
    width: 40px;
    height: 19px;
    left: -4px;
    bottom: -4px;
    position: absolute;
  }
  .icon-bottom-head:after {
    content: '';
    background: url(../images/rightbottom.png) no-repeat;
    width: 40px;
    height: 19px;
    right: -4px;
    bottom: -4px;
    position: absolute;
  }
  .title0{
    margin-top: -15px;
    margin-bottom: 4px;
    height: 30px;
    line-height: 30px;
    width: 100%;
    text-align: center;
    z-index: 999;
    position: relative;
  }
  .title4{
    margin-top: -15px;
    margin-bottom: 4px;
    height: 30px;
    line-height: 30px;
    background-color: rgba(30, 126, 201, 0.33);
    width: 100%;
    text-align: center;
    color: #88fcfc;
    z-index: 999;
    position: relative;
  }
  .title1{
    margin-top: -15px;
    height: 30px;
    line-height: 30px;
    width: 100%;
    text-align: center;
    color: #88fcfc;
    background-color: rgba(30, 126, 201, 0.33);
  }
  .margin-l0{
    margin-left: 0px !important;
  }
  .lb1,.lb2{
    width: 250px !important;
    margin-left: 10px;
  }
  .lb3,.lb5{
    width: 425px !important;
    margin-left: 10px;
  }
  .lb4{
    width: 510px !important;
    margin-left: 10px;
  }
  .lb6,.lb15{
    width: 510px !important;
    margin-left: 10px;
  }
  .lb7,.lb16{
    width: 425px !important;
    margin-left: 10px;
  }
  .lb8,.lb9,.lb14,.lb17,.lb18,.lb21{
    width: 945px !important;
    margin-left: 10px;
  }
  .lb10,.lb11,.lb12,.lb13,.lb19,.lb20,.lb22,.lb23,.lb24,.lb25,.lb26,.lb27{
    width: 467.5px !important;
    margin-left: 10px;
  }

  /* .lb1 div,.lb2 div,.lb3 div,.lb4 div,.lb5 div,.lb6 div,.lb7 div,.lb8 div,.lb9 div,.lb10 div,.lb11 div,.lb12 div,.lb13 div,.lb14 div
  ,.lb15 div,.lb16 div,.lb17 div,.lb18 div,.lb19 div,.lb20 div,.lb21 div,.lb22 div,.lb23 div,.lb24 div,.lb26 div,.lb25 div,.lb27 div */
  /* .widthall{
      width: 100%;
      text-align: center;
  } */
  .lbt1,.lbt2{
    height: 66px;
    line-height: 66px;
    background-color:rgba(6, 103, 197, 0.1);
    width: 100%;
    text-align: center;
    z-index: 999;
    position: relative;
    font-size: 40px;
  }
  .char{
    height: 166px;
    background-color: rgba(6, 103, 197, 0.1) ;
    width: 100%;
    text-align: center;
    z-index: 999;
    position: relative;
  }

  .char1{
    height: 200px;
    background-color: rgba(6, 103, 197, 0.1);
    width: 100%;
    text-align: center;
    z-index: 999;
    position: relative;
  }
  .char2{
    height: 170px;
    width: 100%;
    text-align: center;
  }
  .center-top{
    height: 250px;
  }
  .center-map{
    background-color: rgba(6, 103, 197, 0.1);
    height: 790px;
    z-index: 999;
    position: relative;
  }
  .map-por{
    position: relative;
    z-index: 999;
  }
  .map-min-por{
    position: relative;
    z-index: 999;
    width: 945px;
    margin-left: 10px;
  }
  .box{
    height: 40px;
    overflow: hidden;
    position: absolute;
    top: 60px;
    left: 50%;
    margin-left: -150px;
  }
  .box .sign-box span{
    width: 15px;
  }
  .l{
    float: left;
  }
  .clor-g{
    color: #88fcfc;
  }
  .title2{
    //margin-top: -4px;
    background-color: rgba(30, 126, 201, 0.33);
    width:49.5% !important;
    margin-left: 1%;
    float: left;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
  }
  .number{
    height: 20px;
    line-height: 20px;
    width:49.5% !important;
    margin-left: 1%;
    float: left;
  }
  #lb12 p{
    margin: 5px 10px;
    color: #29b9d7;
    font-size: 16px;
    text-align: left;
  }
  .one{
    width:25% !important;
    float: left;
  }
  .title3{
    //margin-top: -4px;
    background-color: #103d63;
    color: #ffffff;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    text-align: center;
  }
  .one-n{
    height: 125px;
    line-height: 125px;
    font-weight: bold;
    font-size: 40px;
    width: 100%;
    text-align: center;
  }
  .one-v{
    height: 65px;
    line-height: 65px;
    font-size: 40px;
    width: 100%;
    text-align: center;
  }
  .one-t{
    font-size: 16px;
    height: 60px;
    line-height: 60px;
    width: 100%;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .one-t span{
    color: #88fcfc;
    font-size: 18px;
  }
  .red{
    color: #f56c6c !important;
  }
  .zsj{
    overflow:hidden;
    position: absolute;
    left: 10px;
    z-index: 99;
  }
  .zxj{
    overflow:hidden;
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 99;
  }
  .zsj li,.zxj li{
    list-style: none;
    line-height: 24px;
    padding: 4px;
  }
  .zsj li span,.zxj li span{
    color: #88fcfc;
    margin-left: 20px;
  }
  .map-type{
    position: absolute;
    right: 10px;
    margin-top: 10px;
    z-index: 9999;
    color: #fff;
  }
  .map-type:hover{
    color: #fff;
  }
  .map-icon{
    display: block;
    float: left;
    width: 24px;
  }
  .map-text{
    display: block;
    float: right;
    line-height: 24px;
    cursor: pointer;
  }
  .form-lable{
    color: #fff;
    padding: 10px;
    line-height: 20px;
    display: inline-block;
    cursor: pointer;
  }
  .map-icon-ico{
    position: absolute;
    right: 10px;
    margin-top: 60px;
    z-index: 99;
  }
  .link-icon{
    display: block;
    width: 26px;
    height: 26px;
    margin-top: 10px;
    position: relative;
    border: 1px solid #78dedf;
  }
  .link-icon1:before{
    content: '';
    position: absolute;
    background: url(../images/icon1.png) no-repeat;
    background-size: cover;
    width: 18px;
    height: 18px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .link-icon2:before{
    content: '';
    position: absolute;
    background: url(../images/icon2.png) no-repeat;
    background-size: cover;
    width: 18px;
    height: 18px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .link-icon3:before{
    content: '';
    position: absolute;
    background: url(../images/icon3.png) no-repeat;
    background-size: cover;
    width: 18px;
    height: 18px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .link-icon4:before{
    content: '';
    position: absolute;
    background: url(../images/icon4.png) no-repeat;
    background-size: cover;
    width: 18px;
    height: 18px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/module/monitoringCenter/page/operatingView_screen.vue